"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.chunkArray = exports.selectAddress = exports.ERC20Interface = exports.BalancerV1Interface = exports.UniV2Interface = exports.StableSwapInterface = exports.ChainId = exports.initPairsAndFilterByWhitelist = void 0;
const async_1 = require("@celo/utils/lib/async");
// import { ABI as StableSwapABI } from "../types/web3-v1-contracts/ISwap";
const StableSwap_json_1 = __importDefault(require("../tools/abi/StableSwap.json"));
const IUniswapV2Pair_1 = require("../types/web3-v1-contracts/IUniswapV2Pair");
const ISymmetricSwap_1 = require("../types/web3-v1-contracts/ISymmetricSwap");
const ERC20_1 = require("../types/web3-v1-contracts/ERC20");
const abi_1 = require("@ethersproject/abi");
const initPairsAndFilterByWhitelist = async (pairs, tokenWhitelist) => {
    await (0, async_1.concurrentMap)(10, pairs, (p) => p.init());
    return pairs.filter((p) => tokenWhitelist.indexOf(p.tokenA) >= 0 &&
        tokenWhitelist.indexOf(p.tokenB) >= 0);
};
exports.initPairsAndFilterByWhitelist = initPairsAndFilterByWhitelist;
var ChainId;
(function (ChainId) {
    ChainId[ChainId["Celo"] = 42220] = "Celo";
    ChainId[ChainId["Alfajores"] = 44787] = "Alfajores";
})(ChainId = exports.ChainId || (exports.ChainId = {}));
exports.StableSwapInterface = new abi_1.Interface(StableSwap_json_1.default);
exports.UniV2Interface = new abi_1.Interface(JSON.stringify(IUniswapV2Pair_1.ABI));
exports.BalancerV1Interface = new abi_1.Interface(JSON.stringify(ISymmetricSwap_1.ABI));
exports.ERC20Interface = new abi_1.Interface(JSON.stringify(ERC20_1.ABI));
const selectAddress = (chainId, addresses) => {
    switch (chainId) {
        case 42220:
            if (!addresses.mainnet) {
                throw new Error(`no address provided for Mainnet (${chainId})!`);
            }
            return addresses.mainnet;
        case 62320:
            if (!addresses.baklava) {
                throw new Error(`no address provided for Baklava (${chainId})!`);
            }
            return addresses.baklava;
        case 44787:
            if (!addresses.alfajores) {
                throw new Error(`no address provided for Alfajores (${chainId})!`);
            }
            return addresses.alfajores;
        default:
            throw new Error(`unknown chainId: ${chainId}!`);
    }
};
exports.selectAddress = selectAddress;
const chunkArray = (arr, chunkSize) => {
    const chunkedArray = new Array(Math.ceil(arr.length / chunkSize));
    for (let i = 0; i < arr.length; i += chunkSize) {
        chunkedArray[Math.floor(i / chunkSize)] = arr.slice(i, i + chunkSize);
    }
    return chunkedArray;
};
exports.chunkArray = chunkArray;
//# sourceMappingURL=utils.js.map